import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import {
  renderLocationChoice,
  renderLocationInOrNear,
} from '../../../common/components/SearchHeader/types/LocationChoice';
import { pluralize } from '../../../common/util/pluralize';
import { getDayTerm, getSpecialtyPractitionerTerm } from '../renderers';
import { SeoScenario } from '../types';

export const specialtyAppointment: SeoScenario = it => {
  const specialist = getSpecialtyPractitionerTerm(it);
  const practitioners = pluralize(specialist);
  const location = renderLocationChoice(it.location);
  const inOrNear = renderLocationInOrNear(it.location);
  const dayTerm = getDayTerm(it);

  const initialSpecialist = specialist === 'GP' ? 'doctor' : specialist;

  return {
    pageTitle: `Book ${specialist} appointments near you ${dayTerm}${inOrNear} ${location}`,
    metaDescription: `Find a ${specialist} in ${location} and book an appointment online instantly. 1000s of appointments with trusted practitioners available every day. Book a ${specialist} appointment online near you with Healthengine and find trusted ${practitioners} in ${location}`,
    visualHeader: `${specialist} appointments ${dayTerm}${inOrNear} ${location}`,
    textContent: `Book a ${initialSpecialist}'s appointment ${dayTerm}near ${location}. Simply browse all ${specialist} appointments available in and around ${location}, choose a time that suits you and book instantly online!
      ${getAppointmentsMiddleParagraph(it)}
      Healthengine lets you be in complete control of your health and wellness, connecting you with the right ${specialist} when you need it the most. Find and book a ${specialist} online, anywhere in ${location}, anytime. Get started today!`,
  };
};

const getAppointmentsMiddleParagraph = (it: FilterChoice) => {
  const location = renderLocationChoice(it.location);

  switch (it.topic?.specialist) {
    case 'GP':
      return `
      Not only can you book your annual check, Healthengine's network of trusted general physicians in ${location} specialise in everything from skin checks, immunisations, family medicine and minor surgery, chronic disease management, dermatology, care plans and much more.
      `;

    case 'Dentist':
      return `
      Not only can you book your dental exam, Healthengine's network of trusted dentists in ${location} specialise in everything from cleaning, scaling, dental xrays and root canals, to orthodontic treatment, fillings, dental hygiene and much more.
      `;

    case 'Physiotherapist':
      return `
      Healthengine's network of trusted physios in ${location} specialise in everything from injury rehabilitation, sports massage and remedial massage to ultrasound, dry needle therapy, pain management and much more.
      `;

    case 'Chiropractor':
      return `
      Healthengine's network of trusted chiropractors in ${location} specialise in everything from shoulder pain, remedial massages and sciatica injuries to shoulder dislocation, arthritis treatments, kinesiology and much more.
      `;

    case 'Psychologist':
      return `
      Healthengine's network of trusted psychs in ${location} specialise in everything from family therapy, eating disorders, clinical psychology and phobias to postnatal depression, cognitive behavioural therapy, trauma, stress-related illness and much more.
      `;
    default:
      return '';
  }
};
